"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WasfatyRouteOfAdmin_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var WasfatyRouteOfAdmin_Factory = /** @class */ (function () {
    function WasfatyRouteOfAdmin_Factory() {
    }
    WasfatyRouteOfAdmin_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Id: model.Id,
            Name: model.Name,
            SecondLanguageName: model.SecondLanguageName,
        };
        return result;
    };
    WasfatyRouteOfAdmin_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Id: model.Id,
            Name: model.Name,
            SecondLanguageName: model.SecondLanguageName,
        };
        return result;
    };
    return WasfatyRouteOfAdmin_Factory;
}());
exports.WasfatyRouteOfAdmin_Factory = WasfatyRouteOfAdmin_Factory;
